// Module
var code = " <div class=\"gauge-chart-settings\"> <div class=\"form-group form-group-sm\"> <label for=\"column\"> Colonne </label> <select class=\"form-control\" name=\"column\" ng-options=\"column.kid as column.name for column in $ctrl.allowedColumns()\" ng-model=\"$ctrl.settings.column\"></select> </div> </div> ";
// Exports
export default code;